import {
  CommonStorage,
  FeatureStorage,
  NavigationStorage,
} from "../../_services/storage";
import navigationItems from "../../app-navigation";
import roamNavigationItems from "../../app-navigation-gcorp-roam";
import { store } from "../../_store";

import BrowserHelper from "../browser/browser-helper";

let browserHelper = new BrowserHelper();
let isTablet = browserHelper.tablet
  ? true
  : false;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", arguments);
}

function filterMenu(navArray, applicationMode) {
  if (FeatureStorage.getItems() == null) return;

  var featureItems = FeatureStorage.getItems().filter(
    (x) =>
      x.Type == "Work Centre" ||
      x.Type == "Module" ||
      x.Type == "Screen" ||
      x.Type == "Settings Screen"
  );

  var topMenus = [];

  navArray.forEach((tm) => {
    if (tm.applicationFeatureCode) {
      if (applicationMode === "GcorpRoam") {
        if (
          featureItems.some(
            (x) => x.ApplicationFeatureCode == tm.applicationFeatureCode
          )
        ) {
          topMenus.push(tm);
        }
      } else if (
        featureItems.some(
          (x) => x.ApplicationFeatureCode == tm.applicationFeatureCode
        )
      ) {
        // eslint-disable-next-line no-console
        // this.$logger.debug("tm", tm);
        if (!tm.applicationFeatureCode) return;

        let validModules = [];
        // go thorugh the module under each work centre
        if (tm.items) {
          tm.items.forEach((m) => {
            if (
              featureItems.some(
                (x) => x.ApplicationFeatureCode == m.applicationFeatureCode
              )
            ) {
              var validScreens = [];
              // go through each screen for the module 'm'
              if (m.items) {
                m.items.forEach((s) => {
                  if (
                    featureItems.some(
                      (x) =>
                        x.ApplicationFeatureCode == s.applicationFeatureCode
                    )
                  ) {
                    validScreens.push(s);
                  }
                });

                m.items = validScreens;
                // add screens to modules only if there is any
                if (m.items.length > 0) validModules.push(m);
              } else {
                validModules.push(m);
              }
            }
          });

          // eslint-disable-next-line no-console
          // this.$logger.debug("validModules", validModules);
          tm.items = validModules;
          // add module to workcentre only if there is any
          if (tm.items.length > 0) topMenus.push(tm);
        } else {
          topMenus.push(tm);
        }
      }
    } else {
      // add to top menu id the applicationFeatureCode is empty
      if (tm.type == "Global") {
        logDev("top menu", tm);

        let validScreens = [];
        // go thorugh the module under each work centre
        if (tm.items) {
          tm.items.forEach((menu) => {
            if (
              featureItems.some(
                (x) =>
                  x.ApplicationFeatureCode == menu.applicationFeatureCode &&
                  x.WritePermission == "Y"
              )
            ) {
              if (
                menu.applicationFeatureCode == "SalesOrder" &&
                menu.type == "Screen"
              ) {
                let salesOrderScreenVersionInUse = FeatureStorage.getSalesOrderVersionInUse();
                var touchSO = CommonStorage.getItems("TouchSalesOrder");

                if (isTablet && touchSO == 'Y') menu.path = "/t-sales-order/create";
                else if (salesOrderScreenVersionInUse == "V2")
                  menu.path = "/sales-order-v2/create";
                else if (salesOrderScreenVersionInUse == "V3")
                  menu.path = "/sales-order-v3/create";
                else if (salesOrderScreenVersionInUse == "V4") {
                  menu.path = "/sales-order-v4/create";
                } else if (salesOrderScreenVersionInUse == "V4") {
                  menu.path = "/sales-order-v4/create";
                } else if (salesOrderScreenVersionInUse == "V5") {
                  menu.path = "/sales-order-v5/create";
                } else {
                  menu.path = "/sales-order/create";
                }
              }
              if (
                menu.applicationFeatureCode == "PurchaseOrder" &&
                menu.type == "Screen"
              ) {
                var POVersion = CommonStorage.getItems(
                  "PurchaseOrderVersionInUse"
                );
                if (POVersion == "V1") {
                  menu.path = "/purchase-order/create";
                } else {
                  menu.path = `/purchase-order-${POVersion.toLowerCase()}/create`;
                }
              }

              validScreens.push(menu);
            }
          });
        }

        tm.items = validScreens;
        // check for the work center permission
        //
      }

      if (tm.items) {
        if (tm.items.length) topMenus.push(tm);
      } else {
        topMenus.push(tm);
      }
    }
  });

  return topMenus;
}

export function setValidNavigationLinks() {
  let applicationMode = browserHelper.tablet
    ? store.state.profile.applicationMode
    : browserHelper.mobile
      ? "GcorpRoam"
      : store.state.profile.applicationMode
        ? store.state.profile.applicationMode
        : "Gcorp";

  // this.$logger.debug("mobile", browserHelper.mobile);
  // this.$logger.debug("Application Mode: ", applicationMode);
  if (applicationMode == "GcorpRoam") {
    NavigationStorage.saveItems(
      filterMenu(roamNavigationItems, applicationMode)
    );
  } else {
    NavigationStorage.saveItems(filterMenu(navigationItems, applicationMode));
  }
}
